import { AccessTimeOutlined, CalendarTodayOutlined } from '@mui/icons-material';
import styles from './ExecutionMonthEmpty.module.css';

export interface ExecutionMonthEmptyProps {
	variant: 'current' | 'upcoming';
	monthLabel: string;
	onRegister?: () => void;
}

export const ExecutionMonthEmpty = ({ variant, monthLabel, onRegister }: ExecutionMonthEmptyProps) => {
	const isCurrent = variant === 'current';

	return (
		<div className={isCurrent ? styles.currentCard : styles.upcomingCard}>
			{isCurrent ? (
				<CalendarTodayOutlined className={styles.icon} />
			) : (
				<AccessTimeOutlined className={styles.icon} />
			)}
			<p className={styles.text}>
				{isCurrent
					? 'Mês em andamento, nenhuma aplicação lançada até agora.'
					: `Mês ainda não iniciado. A execução abre quando ${monthLabel} começar.`}
			</p>
			{isCurrent ? (
				<button type="button" className={styles.register} onClick={onRegister}>
					Registrar aplicação
				</button>
			) : null}
		</div>
	);
};
